<template>
  <div class="v-tabs relative bg_fff">
    <ul class="flex">
      <li v-for="(d,i) in data" class="flex0 fs16 flex flex-center flex-center-2" :class="{color_main:curr===i}"
          :style="{width:style.width}" @click="curr=i">
        {{ d[mapKey.label] }}
      </li>
    </ul>
    <div class="yb absolute" :style="style">
      <div class="icon"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-tabs",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    defaultCurrIndex: {
      type: Number,
      default: 0
    },
    mapKey: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          value: 'value'
        }
      }
    }
  },
  data() {
    return {
      curr: 0
    }
  },
  computed: {
    length() {
      return this.data.length || 1;
    },
    style() {
      return {
        left: `${this.curr * (100 / this.length)}%`,
        width: `${100 / this.length}%`
      }
    }
  },
  watch: {
    curr: {
      handler(newV) {
        this.$emit('change', this.data[this.curr]);
      },
      immediate: true
    }
  },
  created() {
    this.curr = this.defaultCurrIndex;
  },
  methods: {
    setCurr(curr) {
      if (this.curr === curr) return;
      this.curr = curr;
    }
  },
}
</script>

<style scoped lang="scss">
@import "../common/public";

%ani {
  transition: all ease-in-out 200ms;
}

.v-tabs {
  height: px2rem(45px);

  li {
    height: px2rem(45px);
    @extend %ani;
  }

  .yb {
    @extend %ani;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;

    .icon {
      width: 32px;
      height: 3px;
      background-color: $mainColor;
      border-radius: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/v-tabs.vue